import {observer} from "mobx-react-lite";
import {DocumentRunnerStatusProps} from "../../../../entity/props/title/document-runner-status-props";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, {useEffect, useState} from "react";
import { ScraperSection } from "../../../../entity/enums/scraper-section";
import CheckIcon from "@mui/icons-material/Check";
import LoadingComponent from "../widget/LoadingComponent";

import '../../../../assets/css/style.css';
import '../../../../assets/css/title/section-dialog.css';

const DocumentRunnerStatusDialog = (props: DocumentRunnerStatusProps): JSX.Element => {
    const [propertyCardStatus, setPropertyCardStatus] = useState<boolean>(false);
    const [taxInfoStatus, setTaxInfoStatus] = useState<boolean>(false);
    const [deedStatus, setDeedStatus] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const tableHeaders = [
        'County',
        'Property Card',
        'Tax Info',
        'Deeds',
        'Status'
    ];

    useEffect(() => {
        const init = (): void => {
            setLoading(true);

            if (props.config) {
                const config = props.config;
                setMessage(config.message);

                if (!config.status) {
                    setPropertyCardStatus(false);
                    setTaxInfoStatus(false);
                    setDeedStatus(false);
                } else
                    switch (config.scraperSection) {
                        case ScraperSection.PROPERTY_CARD:
                            setPropertyCardStatus(true);
                            setTaxInfoStatus(false);
                            setDeedStatus(false);
                            break;

                        case ScraperSection.TAX_DOCUMENTS:
                            setPropertyCardStatus(false);
                            setTaxInfoStatus(true);
                            setDeedStatus(false);
                            break;

                        case ScraperSection.PROPERTY_CARD_AND_TAX_DOCUMENTS:
                            setPropertyCardStatus(true);
                            setTaxInfoStatus(true);
                            setDeedStatus(false);
                            break;

                        case ScraperSection.DEEDS:
                            setPropertyCardStatus(false);
                            setTaxInfoStatus(false);
                            setDeedStatus(true);
                            break;

                        default:
                            setPropertyCardStatus(true);
                            setTaxInfoStatus(true);
                            setDeedStatus(true);
                            break;
                    }
            } else {
                setPropertyCardStatus(false);
                setTaxInfoStatus(false);
                setDeedStatus(false);
                setMessage('Coming soon ...');
            }

            setLoading(false);
        }

        init();
    }, []);

    const renderDocumentStatus = (status: boolean): JSX.Element => {
        return (
            <TableCell className={'table-cell-text'} align={'center'}>
                {
                    status
                        ? <CheckIcon color={'success'}/>
                        : <CloseIcon color={'error'}/>
                }
            </TableCell>
        );
    }

    return (
        <Dialog open={props.open}>
            <DialogTitle className={'zitles-dialog-title'}>
                <span>Document Runner Status</span>
                <IconButton onClick={(): void => props.setOpen(false)}>
                    <CloseIcon className={'dialog-icon'}/>
                </IconButton>
            </DialogTitle>
            <DialogContent className={'zitles-dialog-content'}>
                <Paper className={'table-container'} elevation={0}>
                    <TableContainer className={'zitles-table'}>
                        <Table>
                            <TableHead>
                                <TableRow className={'table-header'}>
                                    {
                                        tableHeaders.map((header: string, index: number): JSX.Element => (
                                            <TableCell key={index} align='center' padding='normal'>
                                                <Typography className={`data-table-header`}>{header}</Typography>
                                            </TableCell>
                                        ))
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    loading
                                        ? <LoadingComponent/>
                                        : <TableRow
                                            hover
                                            tabIndex={-1}
                                            className={'table-cell'}>
                                            <TableCell className={'table-cell-text'} align={'center'}>{props.county.name}</TableCell>
                                            {
                                                renderDocumentStatus(propertyCardStatus)
                                            }
                                            {
                                                renderDocumentStatus(taxInfoStatus)
                                            }
                                            {
                                                renderDocumentStatus(deedStatus)
                                            }
                                            <TableCell className={'table-cell-text'} align={'center'}>{message}</TableCell>
                                          </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </DialogContent>
        </Dialog>
    );
}

export default observer(DocumentRunnerStatusDialog);
